var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.params.locale || 'sk'}),_c('ExitModal',{attrs:{"showModal":_vm.showModal},on:{"update-value":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }